module.exports = __webpack_public_path__ + "static/media/gallery5.a1f87d47.jpg";